import Link from "next/link";
import { returnUrlTypeCategory } from "~/utils/utils";

const CategoryArticle = ({ category }) => {
  const mainCategory = [];
  const parentCategory = [];

  if (category?.catHeading != undefined) {
    if (category?.catHeading?.parentSlug == null) {
      mainCategory.push({
        name: category?.catHeading?.name,
        slug: returnUrlTypeCategory(
          category?.catHeading?.slug,
          category?.catHeading?.taxonomy
        ),
      });
    }
  } else {
    category?.main?.map((mainCat) => {
      if (
        category?.sub?.filter((subCat) => mainCat.name == subCat.parentName) ==
        false
      ) {
        mainCategory.push({
          name: mainCat.name,
          slug: returnUrlTypeCategory(mainCat.slug, mainCat.taxonomy),
        });
      }
    });
  }
  const subCategory = (
    category?.catHeading != undefined
      ? category?.catHeading?.parentSlug != null
        ? [category?.catHeading]
        : []
      : category.sub
  ).reduce((acc, { name, slug, parentName, parentSlug, taxonomy }) => {
    if (!acc[parentName]) {
      acc[parentName] = {
        parent: {
          name: parentName,
          slug: returnUrlTypeCategory(parentSlug, taxonomy),
        },
        childre: [
          {
            name: name,
            slug: returnUrlTypeCategory(slug, taxonomy),
          },
        ],
      };
      parentCategory.push(parentName);
    } else {
      acc[parentName].childre.push({
        name: name,
        slug: returnUrlTypeCategory(slug, taxonomy),
      });
    }
    return acc;
  }, []);

  return (
    <ul>
      {mainCategory &&
        mainCategory.map((main, index) => (
          <li key={index} className="inline">
            <>
              <Link
                className="font-medium text-black"
                key={main.slug}
                href={main.slug == "/s/speciali" ? "/speciali" : main.slug}
              >
                {main.name}
              </Link>
              {parentCategory.length > 0 || index < mainCategory.length - 1
                ? ", "
                : ""}
            </>
          </li>
        ))}
      {Boolean(parentCategory) && parentCategory.length > 0 && (
        <li className="inline">
          {parentCategory.map((sub) => (
            <>
              <>
                <Link
                  className="font-medium text-black"
                  key={
                    subCategory[sub].parent.slug == "/s/speciali"
                      ? "/speciali"
                      : subCategory[sub].parent.slug
                  }
                  href={
                    subCategory[sub].parent.slug == "/s/speciali"
                      ? "/speciali"
                      : subCategory[sub].parent.slug
                  }
                >
                  {subCategory[sub].parent.name}
                </Link>
                <span> / </span>
              </>
              {subCategory[sub].childre.map((chil, index) => (
                <>
                  <Link className="" key={chil.slug} href={chil.slug}>
                    {chil.name}
                  </Link>
                  {index < subCategory[sub].childre.length - 1 ? ", " : ""}
                </>
              ))}
            </>
          ))}
        </li>
      )}
    </ul>
  );
};
export default CategoryArticle;
